import { Token, Grant } from 'svc-auth-sdk-node/src/account-center'
const authorizationCode = new Grant.AuthorizationCode({
  env: process.env.REACT_APP_AUTH_ENV,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
  client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_AUTH_CLIENT_REDIRECT_URI,
})
export default Token;
export { authorizationCode, Token }
